import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61c778b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-12" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-200px symbol-fixed position-relative" }
const _hoisted_6 = { class: "symbol symbol-200px" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-img overlay-layer" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-white" }, " image_search ")
], -1))
const _hoisted_8 = { class: "flex-grow-1" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "d-flex align-items-center mb-2" }
const _hoisted_12 = { class: "text-gray-800 fs-2 fw-bolder me-1" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  class: "text-success ms-2"
}
const _hoisted_16 = {
  key: 0,
  class: "svg-icon svg-icon-1 svg-icon-success",
  "data-bs-toggle": "tooltip",
  "data-bs-custom-class": "tooltip-dark",
  "data-bs-placement": "top",
  title: "Verified"
}
const _hoisted_17 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_18 = { class: "svg-icon svg-icon-4 me-3" }
const _hoisted_19 = { class: "d-flex flex-wrap" }
const _hoisted_20 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_21 = { class: "d-flex flex-wrap row gx-9 gy-3" }
const _hoisted_22 = { class: "border border-gray-300 border-dashed rounded h-100px d-flex flex-column justify-content-center" }
const _hoisted_23 = { class: "fs-3x fw-bolder text-center" }
const _hoisted_24 = { class: "fw-bold fs-6 text-gray-400 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "overlay cursor-pointer",
              "data-bs-toggle": "modal",
              "data-bs-target": "#modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
                $setup.changeImage(
                  $props.data.profileImage ||
                    $props.data.images?.[0]?.image ||
                    $setup.placeholderImage
                )
              ))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  style: _normalizeStyle(`background-image: url('${
                    $props.data.profileImage ||
                    $props.data.images?.[0]?.image ||
                    $setup.placeholderImage
                  }')`),
                  class: "custom-image-box"
                }, null, 4),
                _hoisted_7
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (!$props.isCar)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($props.data.name || '-'), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString($props.data.series?.name + ' ' + $props.data.color?.name || '-'), 1)),
                  ($props.isCar)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($props.data.plate || '-'), 1))
                    : _createCommentVNode("", true)
                ]),
                ($props.data.verifyState === 'Done')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.personalDetails, (detail, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "d-flex align-items-center text-gray-400 me-5 mb-2"
                  }, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, {
                        src: detail.svg
                      }, null, 8, ["src"])
                    ]),
                    _createTextVNode(" " + _toDisplayString(detail.name || '-'), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stats, (stat, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "col-lg-3"
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(stat.number), 1),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(stat.label), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}